import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class BasePaddleNumbersApiService extends GbApiService {
  checkPaddleNumberAvailable(
    paddle_number: string,
    urlName: string = '',
  ): Observable<void | {
    paddle_number: string
  }> {
    const url = `auctions/${urlName}/check-paddle-number-available/`
    return this.post(url, {
      paddle_number,
    })
  }

  getNextAvailablePaddleNumber(urlName: string): Observable<{
    paddle_number: string
  }> {
    const url = `auctions/${urlName}/next-available-paddle-number/`
    return this.get(url)
  }
}
